export default __webpack_public_path__ + "static/media/cash.fd8c1551.svg";